var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isSuperAdmin)?_c('company-route-tabs',{attrs:{"company-id":_vm.companyId}}):_vm._e(),_c('company-cloudcanteen-form',{attrs:{"company-id":_vm.companyId,"entity-id":_vm.cloudcanteenId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }